import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core'
import { PermissionService } from './permission.service'
import { Subscription } from 'rxjs'

@Directive({
  selector: '[ruleAuthorized]'
})
export class RuleAuthorizedDirective{

  private _subscription: Subscription = new Subscription()
  currentIsAuthed = false

  @Input()
  set ruleAuthorized(rules: string[]) {
    if (!!this._subscription) {
      this._subscription.unsubscribe()
    }

    this._subscription = this._permissionService.canActiveRule(rules)
      .subscribe(canActivate => {
        if (canActivate) {
          if(!this.currentIsAuthed) {
            this._vcr.createEmbeddedView(this._templateRef)
          }
        } else {
          this._vcr.clear()
        }
        this.currentIsAuthed = canActivate
      })
  }

  constructor(
    private _permissionService: PermissionService,
    private _templateRef: TemplateRef<any>,
    private _vcr:ViewContainerRef
  ) { }

}
